export default ({ min, max }: FixmeType) =>
    ({}) => {
        return {
            xAxis: {
                min,
                max,
            },
        };
    };
